import { render } from "./SwitchDialog.vue?vue&type=template&id=3c60ba84&scoped=true"
import script from "./SwitchDialog.vue?vue&type=script&lang=js"
export * from "./SwitchDialog.vue?vue&type=script&lang=js"

import "./SwitchDialog.vue?vue&type=style&index=0&id=3c60ba84&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c60ba84"]])

export default __exports__